import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { TypeLine } from '@/components/TypeLine';

const BOOT_LINES = [
  'RetroOS BIOS v3.12',
  'Copyright (C) 1989–1996',
  '',
  'Initializing memory… OK',
  'Detecting display adapter… OK',
  'Mounting filesystem… OK',
  'Launching desktop shell…',
] as const;

const BootRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fading',
})<{ fading?: boolean }>(({ theme, fading }) => ({
  position: 'absolute',
  inset: 0,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  padding: theme.spacing(4),
  zIndex: 50,
  pointerEvents: 'none',

  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),

  /* Fade-out */
  opacity: fading ? 0 : 1,
  transition: 'opacity 600ms ease-out',
}));

export function BootOverlay({ onComplete }: { onComplete: () => void }) {
  const [phase, setPhase] = useState<'boot' | 'blank' | 'fade'>('boot');
  const [lineIndex, setLineIndex] = useState(0);

  const bootComplete = lineIndex >= BOOT_LINES.length;

  useEffect(() => {
    if (!bootComplete) return;

    const blankTimer = setTimeout(() => setPhase('blank'), 500);
    const fadeTimer = setTimeout(() => setPhase('fade'), 900);
    const doneTimer = setTimeout(onComplete, 1500);

    return () => {
      clearTimeout(blankTimer);
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [bootComplete, onComplete]);

  return (
    <BootRoot fading={phase === 'fade'}>
      {phase === 'boot' && (
        <Box>
          {BOOT_LINES.slice(0, lineIndex + 1).map((line, i) =>
            i === lineIndex ? (
              <TypeLine
                key={i}
                text={line}
                onComplete={() => setLineIndex((v) => v + 1)}
              />
            ) : (
              <TypeLine key={i} text={line} speed={0} />
            )
          )}
        </Box>
      )}
    </BootRoot>
  );
}
